import { Components } from '@mui/material/styles'

export const MuiTextFieldOverrides: Components['MuiTextField'] = {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        borderRadius: 1, // 8px (1 * 8px)
      },
    },
  },
}
